import { Stack, styled } from "@mui/material";
import { FatButton } from "components/ui";
import { FC } from "react";
import { CheckCircle } from "@mui/icons-material";

interface Props {
  upper: boolean;
  lower: boolean;
  onClickUpper: () => void;
  onClickLower: () => void;
}

const ICON = (
  <CheckCircle
    sx={{ ml: 1, width: "0.85em", height: "0.85em", verticalAlign: "text-top" }}
  />
);

const SpanWrapper = styled("span")`
  display: flex;
  width: 120px;
  white-space: nowrap;
  place-content: center;
  align-items: stretch;
`;

export const ArchesStepContainer: FC<Props> = ({
  upper,
  lower,
  onClickUpper,
  onClickLower,
}) => {
  return (
    <Stack spacing={3} direction="row" sx={{ mt: 3 }}>
      <FatButton
        data-intercom-target="Upper arch button"
        onClick={onClickUpper}
        variant={upper ? "contained" : "outlined"}
      >
        <SpanWrapper>Upper Arches{upper ? ICON : ""}</SpanWrapper>
      </FatButton>
      <FatButton
        data-intercom-target="Lower arch button"
        onClick={onClickLower}
        variant={lower ? "contained" : "outlined"}
      >
        <SpanWrapper>Lower Arches{lower ? ICON : ""}</SpanWrapper>
      </FatButton>
    </Stack>
  );
};
